<template>
    <div style="padding: 100px 8%;">
        <div class="col-12">
            <h4>編輯保障群組</h4>
            <form class="form panel panel-form bg-white">
                <div class="row">
                    <div class="col-4">
                        <label class="d-inline-block" for="">群組編號：
                            <span class="text-secondary">{{ midCode }}</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="">十大保障大類：
                            <span class="text-secondary">{{ bigName }}({{ bigCode }})</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="midName">群組名稱：</label>
                        <input class="form-control form-control-inline w-50" id="midName" v-model="midName"/>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="">更新日期：
                            <span class="text-secondary">{{ currentDate }}</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="memo">備註：</label>
                        <input class="form-control form-control-inline w-75" id="memo" v-model="midMemo"/>
                    </div>
                </div>
                <hr class="hr-dashed mg-b-40"> <!--分隔線-->
                <div class="block-b mg-b-40">
                    <div class="width-45">
                      <div class="mg-b-8">
                        <span class="col-3 text-black-50">後台保障細項：</span>
                      </div>
                      <div class="border-s-2">
                        <div class="flex mg-b-8 mg-l-4">
                          <!-- <div class="input-group input-lg width-60 mg-r-8"> -->
                          <div class="input input-lg width-60 mg-r-8">
                            <div class="input">
                              <input
                                type="text"
                                name="Search"
                                id="Search"
                                class="form-control"
                                v-model="keyword"
                                @keydown.enter="doSearch()"
                                placeholder="保障項目編號、說明"
                                maxlength="40"
                                @input="checkKeyword"
                              />
                              <!-- <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                                >清除</span
                              > -->
                            </div>
                            <!-- <button
                              class="btn btn-primary btn-icon"
                              type="submit"
                              @click.prevent="doSearch()"
                            >
                              <i class="icon-search i-24"></i>
                            </button> -->
                          </div>
                          <div class="checkbox radio-inline width-40 text-size">
                            <input type="checkbox" id="not-join-group" v-model="notJoinGroup"/>
                            <label for="not-join-group">尚未加入群組</label>
                          </div>

                        </div>
                        <div>
                          <select
                            multiple="multiple"
                            class="form-control form-control-inline selectBox1"
                            v-model="leftSelect"
                          >
                          <option
                            v-for="(item, index) in showSmallCategoryAll"
                            :key="index"
                            :value="item"
                            >
                            {{ item.sequencenumber }} - {{item.name }}
                          </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-2 width-10 d-inline-center">                      
                      <button type="button" class="btn btn-default delectBox-button" @click="addSmallCategory()">
                          加入&gt;&gt;
                      </button>
                      <br/>
                      <br/>
                      <button type="button" class="btn btn-default delectBox-button" @click="removeSmallCategory()">
                          &lt;&lt;移除
                      </button>                                           
                    </div>
                    <div class="width-45">
                      <div class="mg-b-8">
                          <span class="col-3 text-black-50">被納入群組的保障：</span>
                      </div>
                      <div class="border-s-2">
                        <select
                        multiple="multiple"
                        class="form-control form-control-inline selectBox2"
                        v-model="rightSelect"
                        >
                        <option
                          v-for="(item, index) in showHasInGroupCategory"
                          :key="index"
                          :value="item"
                          >
                          {{ item.sequencenumber }} - {{item.name }}
                        </option>
                      </select>
                      </div>
                    </div>
                </div>
                <div class="d-flex mg-b-40">
                    <label class="flex-shrink-0 mr-2" for="reason">異動原因：</label>
                    <textarea class="form-control" id="reason" v-model="memoString" :disabled="isCheckButton" rows="4" cols="120"></textarea>
                </div>
                <div class="block-d mg-b-40">
                    <a @click="doCancel()" class="btn btn-default">取消</a>
                    <a @click="onSave()" class="btn btn-primary" :disabled="!isSaveButton">存檔</a>
                    <a @click="onCheck()" class="btn btn-primary" :disabled="!isCheckButton">覆核生效</a>
                </div>
                <div class="block-e mg-b-40">
                  <record-data-table :data="changeRecords"></record-data-table>
                </div>
            </form>
        </div>
        <ConfirmModal
            :open="confirmModalOpen"
            @confirm="onConfirm"
            @close="panelClose('confirmModalOpen')">
            <template slot="title">
                <template v-if="confirmType === 'save'">是否確認要儲存？</template>
                <template v-else-if="confirmType === 'check'">是否確認要覆核生效？</template>
            </template>
        </ConfirmModal>
    </div>
</template>

<script>
import ThisMixin from "../util/CoverageCategory.js";
import ConfirmModal from "./ConfirmModal.vue";
import RecordDataTable from "./RecordDataTable.vue";
import {
  querySaveId,
  querySmallCategoryAll,
  queryChangeRecords,
  queryNotJoinGroup,
  querySmallCategoryByCode,
  querySmallCategoryNotCheckByCode,
  querySmallCategoryNotCheckByCode2,
  insertDTMVZ006,
  insertDTMVZ006MID,
  doCheckCategory,
} from "@/service";

export default {
  name: "MidCategoryEditModal",
  mixins: [ThisMixin],
  components: { 
      ConfirmModal,
      RecordDataTable,
  },
  data() {
    return {
      //使用者ID
      userID: "",
      userName: "",
      //存檔者ID
      saveID: "",
      //存檔按鈕,預設停用
      isSaveButton: false,
      //覆核按鈕,預設停用
      isCheckButton: false,
      //現在日期
      currentDate: "",
      bigCode: "",
      bigName: "",
      midCode: "",
      midName: "",
      midMemo: "",
      isz005exist: false,
      //存放異動原因
      memoString: "",
      //左側-選擇的值
      leftSelect: [],
      //左側-存放的所有保障細項
      smallCategoryAll: [],
      //左側-顯示的保障細項
      showSmallCategoryAll: [],
      //左側-存放尚未加入群組的細項
      notJoinGroupCategory: [],
      detailAll: "",
      changeRecords: [],
      //搜尋條件
      keyword: "",
      notJoinGroup: false,
      //右側-選擇的值
      rightSelect: [],
      //存放已存在的保障細項(原始)
      originalInDTMVZ005: [],
      //右側-存放已加入的保障細項(原始)
      originalInGroupCategory: [],
      //右側-顯示已加入的保障細項
      showHasInGroupCategory: [],
      //存放需要新增的細項
      needInsertCategory: [],
      //存放需要刪除的細項
      needDeleteCategory: [],
      //存放中項
      midCategory: [],
      // 群組名稱改動次數
      midNameChange:0,
      // 中項備註改動次數
      midMemoChange:0,
      // 細項有無更動
      // changeDetail:true,
      // 確認彈窗開關
      confirmModalOpen: false,
      // 確認彈窗類型 (save:存檔, check:覆核生效)
      confirmType: ""
    };
  },
  props: {},
  mounted() {
    this.init();
  },
  watch: {
    notJoinGroup: function (val) {
      // 尚未加入群組勾或不勾都要查詢
      this.doSearch();
    },
    midMemo: function (val) {
      // 中項備註改動次數+1
      this.midMemoChange++ 
    },
    midName: function (val) {
      // 群組名稱改動次數+1
      this.midNameChange++
    },
  },
  methods: {
    /** 初始化用 */
    init() {
      this.userID = this.$store.state.userInfo.id;
      this.userName = this.$store.state.userInfo.name;
      this.currentDate = this.getCurrentDate();
      this.bigCode = this.$route.params.big.codeCategory;
      this.bigName = this.$route.params.big.name;
      this.midCode = this.$route.params.mid.code;
      this.midName = this.$route.params.mid.code_name;
      this.midMemo = this.$route.params.mid.memo;
      this.isz005exist = this.$route.params.mid.isz005exist;
      this.seq = this.$route.params.mid.seq;
      this.getSaveId();
      this.getChangeRecords();
      this.getNotJoinGroup();
      this.getSmallCategoryAll();
      this.getSmallCategoryByCode();
    },
    /** 刷新頁面用 */
    refshPage() {
      this.memoString = "";
      this.needInsertCategory.length = 0;
      this.needDeleteCategory.length = 0;
      this.getSaveId();
      this.getChangeRecords();
      this.getNotJoinGroup();
      this.getSmallCategoryAll();
      this.getSmallCategoryByCode();
    },
    /** 查詢目前存檔的使用者 */
    async getSaveId() {
      await querySaveId(this.userID, this.midCode).then((result) => {
        if (result.header && result.header.status == "200") {
          if (result.data.length > 0) {
            this.saveID = result.data[0].creator;
          }
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
      //(沒有存檔者)或(使用者等於存檔者)
      if (this.saveID == "" || this.userID === this.saveID) {
        this.isSaveButton = true;
      }
      //(有存檔者)且(使用者不等於存檔者)
      if (this.saveID != "" && this.userID !== this.saveID) {
        this.isCheckButton = true;
      }
    },
    /** 取得所有保障細項 */
    async getSmallCategoryAll() {
      await querySmallCategoryAll(this.userID).then((result) => {
        if (result.header && result.header.status == "200") {
          this.smallCategoryAll = result.data;
          this.showSmallCategoryAll = [...this.smallCategoryAll];
          this.setSortCategory();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    /** 取得尚未加入群組的細項 */
    async getNotJoinGroup() {
      await queryNotJoinGroup(this.userID).then((result) => {
        if (result.header && result.header.status == "200") {
          this.notJoinGroupCategory = result.data;
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    /** 取得異動紀錄 */
    async getChangeRecords() {
      await queryChangeRecords(this.userID, this.midCode).then((result) => {
        if (result.header && result.header.status == "200") {
          this.changeRecords = result.data;
        } else {
          this.$toast.info({ title: "異動紀錄:" + result.header.message });
        }
      });
    },
    /** 搜尋清除特殊字元 */
    checkKeyword() {
      this.keyword = this.cleanSpecialChar(this.keyword);
      if (this.stringBytes(this.keyword, false, 40) > 40) {
        this.keyword = this.keyword.substring(
          0,
          this.stringBytes(this.keyword, true, 40)
        );
      }
      // 每次輸入欄更新查詢
      this.doSearch();
    },
    /** 清除搜尋 */
    // cleanSearch() {
    //   this.keyword = "";
    //   this.notJoinGroup = false;
    // },
    /** 搜尋 */
    doSearch() {
      if (this.keyword && this.notJoinGroup) {
        //有關鍵字and有打勾
        this.showSmallCategoryAll = this.notJoinGroupCategory.filter(
          (item) =>
            item.sequencenumber.toString().includes(this.keyword) ||
            item.name.includes(this.keyword)
        );
      } else if (this.keyword && !this.notJoinGroup) {
        //有關鍵字and沒有打勾
        this.showSmallCategoryAll = this.smallCategoryAll.filter(
          (item) =>
            item.sequencenumber.toString().includes(this.keyword) ||
            item.name.includes(this.keyword)
        );
      } else if (!this.keyword && this.notJoinGroup) {
        //沒有關鍵字and有打勾
        this.showSmallCategoryAll = this.notJoinGroupCategory;
      } else {
        //沒有關鍵字and沒有打勾
        this.showSmallCategoryAll = this.smallCategoryAll;
      }
      this.setSortCategory();
    },
    /** 排序左側顯示的保障細項 */
    setSortCategory() {
      this.showSmallCategoryAll.sort(function(a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
    /** 取得已加入群組保障細項 */
    async getSmallCategoryByCode() {
      //查詢已存在dtmvz005的
      await querySmallCategoryByCode(this.userID, this.midCode).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.originalInGroupCategory = [...result.data];
            this.originalInDTMVZ005 = [...result.data];
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
      //查詢存在dtmvz006要新增的
      await querySmallCategoryNotCheckByCode(this.userID, this.midCode).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            if (result.data) {
              result.data.forEach((item) => {
                // API 已將欄位名稱由 name 改為 detail_name，對應轉換以維持畫面一致性
                item.name = item.detail_name;
                this.originalInGroupCategory.push(item);
              });
            }
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );  
      //查詢存在dtmvz006要移除的
      await querySmallCategoryNotCheckByCode2(this.userID, this.midCode).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            if (result.data) {
              for(let i = 0; i < result.data.length; i++) {
                this.originalInGroupCategory = this.originalInGroupCategory.filter((item)=>item.coveragecategoryid!==result.data[i].coveragecategoryid);
              }
            }
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
      //呈現右側最後要顯示的結果
      this.showHasInGroupCategory = [...this.originalInGroupCategory];
    },
    /** 左側加入到右側 */
    addSmallCategory() {
      for (let i = 0; i < this.leftSelect.length; i++) {
        let canJoin = true;
        for (let j = 0; j < this.showHasInGroupCategory.length; j++) {
          if (
            this.leftSelect[i].coveragecategoryid ===
            this.showHasInGroupCategory[j].coveragecategoryid
          ) {
            this.$toast.info({
              title: this.leftSelect[i].name + "→已加入群組內，請重新選擇"
            });
            canJoin = false;
            continue;
          }
        }
        if (canJoin) {
          this.showHasInGroupCategory.push(this.leftSelect[i]);
        }
      }
    },
    /** 右側刪除 */
    removeSmallCategory() {
      for (let i = 0; i < this.rightSelect.length; i++) {
        this.showHasInGroupCategory = this.showHasInGroupCategory.filter(
          (item) =>
            item.coveragecategoryid !== this.rightSelect[i].coveragecategoryid
        );
      }
    },
    /** 取消 */
    doCancel() {
      //回到上一頁
      this.$router.go(-1);
    },
    /** 存檔 */
    onSave() {
      if (!this.memoString.trim()) {
        this.$toast.info({ title: "請填入異動原因" });
        return;
      }
      this.confirmType = "save";
      this.panelOpen("confirmModalOpen");
    },
    async doSave() {
      // 每次存檔前先清空，避免重複累積上一次資料
      this.needInsertCategory = [];
      this.needDeleteCategory = [];

      //找出要新增的array
      let tempInsertCategory = [...this.showHasInGroupCategory];
      for (let i = 0; i < this.originalInGroupCategory.length; i++) {
        tempInsertCategory = tempInsertCategory.filter(
          (item) =>
            item.coveragecategoryid !==
            this.originalInGroupCategory[i].coveragecategoryid
        );
      }
      //找出要移除的array
      let tempDeleteCategory = [...this.originalInGroupCategory];
      for (let i = 0; i < this.showHasInGroupCategory.length; i++) {
        tempDeleteCategory = tempDeleteCategory.filter(
          (item) =>
            item.coveragecategoryid !==
            this.showHasInGroupCategory[i].coveragecategoryid
        );
      }

      //找出要更新detail_name的array(同一個coverageCategoryId但名稱變更)
      let tempUpdateCategory = [];
      for (let i = 0; i < this.showHasInGroupCategory.length; i++) {
        const currentItem = this.showHasInGroupCategory[i];
        const originalItem = this.originalInGroupCategory.find(
          (item) => item.coveragecategoryid === currentItem.coveragecategoryid
        );
        if (originalItem && originalItem.name !== currentItem.name) {
          tempUpdateCategory.push(currentItem);
        }
      }

      // 中項(名稱/備註)是否有異動，需同步到既有細項
      const isMidChanged = this.midNameChange !== 1 || this.midMemoChange !== 1;
      if (isMidChanged) {
        for (let i = 0; i < this.showHasInGroupCategory.length; i++) {
          const currentItem = this.showHasInGroupCategory[i];
          const isInsert = tempInsertCategory.some(
            (item) => item.coveragecategoryid === currentItem.coveragecategoryid
          );
          const isDelete = tempDeleteCategory.some(
            (item) => item.coveragecategoryid === currentItem.coveragecategoryid
          );
          const isUpdate = tempUpdateCategory.some(
            (item) => item.coveragecategoryid === currentItem.coveragecategoryid
          );

          // 既有且仍在群組內的細項，補一筆U讓後端同步中項資訊
          if (!isInsert && !isDelete && !isUpdate) {
            tempUpdateCategory.push(currentItem);
          }
        }
      }

      // 新增檢核只要群組名稱或備註有改動也可以存檔
      if(!tempInsertCategory.length && !tempDeleteCategory.length && !tempUpdateCategory.length && 1 == this.midNameChange && 1 == this.midMemoChange) {
        this.$toast.info({title:  "沒有異動，無須存檔"});
        return;
      }

      //編輯中項資料
      this.midCategory = []
      let tempMidMap = {
        seq: "",
        code_category: "",
          code: "",
          code_name: "",
          detail_name: "",
          coverageCategoryId: "",
          modification_type: "I",
          memo: "", // 備註
          modification_reason: "", // 異動原因
          status: "0",
          creator: "",
          creatorname: "",
        };
        tempMidMap.seq = this.seq;
        tempMidMap.code_category = this.bigCode;
        tempMidMap.code = this.midCode;
        tempMidMap.code_name = this.midName;
        tempMidMap.memo = this.midMemo;
        tempMidMap.modification_reason = this.memoString;
        if(this.midNameChange == 1 && this.midMemoChange == 1 ){
          tempMidMap.modification_type = "I";
        } else if(this.isz005exist){
          tempMidMap.modification_type = "U";
        }
        tempMidMap.creator = this.userID;
        tempMidMap.creatorname = this.userName;
        this.midCategory.push(tempMidMap);
        await insertDTMVZ006MID(this.userID, this.midCategory).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "加入保障中項成功" });
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
          );
        this.midMemoChange = 1
        this.midNameChange = 1

      //整理要新增的資料
      if (tempInsertCategory.length) {
        for (let i = 0; i < tempInsertCategory.length; i++) {
          let tempInsertMap = {
            code_category: "",
            code: "",
            code_name: "",
            detail_name: "",
            coverageCategoryId: "",
            modification_type: "I",
            modification_reason: "",
            status: "0",
            creator: "",
            creatorname: "",
          };
          tempInsertMap.code_category = this.bigCode;
          tempInsertMap.code = this.midCode;
          tempInsertMap.code_name = this.midName;
          tempInsertMap.detail_name = tempInsertCategory[i].name;
          tempInsertMap.coverageCategoryId =
            tempInsertCategory[i].coveragecategoryid;
          tempInsertMap.modification_reason = this.memoString;
          tempInsertMap.creator = this.userID;
          tempInsertMap.creatorname = this.userName;
          this.needInsertCategory.push(tempInsertMap);
        }
        //開始新增
        await insertDTMVZ006(this.userID, this.needInsertCategory).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "加入保障細項成功" });
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
        );
      }
      //整理要移除的資料
      if (tempDeleteCategory.length) {
        for (let i = 0; i < tempDeleteCategory.length; i++) {
          let tempInsertMap = {
            code_category: "",
            code: "",
            code_name: "",
            detail_name: "",
            coverageCategoryId: "",
            modification_type: "D",
            modification_reason: "",
            status: "0",
            creator: "",
            creatorname: "",
          };
          tempInsertMap.code_category = this.bigCode;
          tempInsertMap.code = this.midCode;
          tempInsertMap.code_name = this.midName;
          tempInsertMap.detail_name = tempDeleteCategory[i].name;
          tempInsertMap.coverageCategoryId =
            tempDeleteCategory[i].coveragecategoryid;
          tempInsertMap.modification_reason = this.memoString;
          tempInsertMap.creator = this.userID;
          tempInsertMap.creatorname = this.userName;
          this.needDeleteCategory.push(tempInsertMap);
        }
        //開始新增
        await insertDTMVZ006(this.userID, this.needDeleteCategory).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "移除保障細項成功" });
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
        );
      }

      //整理要更新的資料(包含detail_name異動、或中項異動需同步既有細項)
      if (tempUpdateCategory.length) {
        let needUpdateCategory = [];
        for (let i = 0; i < tempUpdateCategory.length; i++) {
          let tempUpdateMap = {
            code_category: "",
            code: "",
            code_name: "",
            detail_name: "",
            coverageCategoryId: "",
            modification_type: "U",
            modification_reason: "",
            status: "0",
            creator: "",
            creatorname: "",
          };
          tempUpdateMap.code_category = this.bigCode;
          tempUpdateMap.code = this.midCode;
          tempUpdateMap.code_name = this.midName;
          tempUpdateMap.detail_name = tempUpdateCategory[i].name;
          tempUpdateMap.coverageCategoryId =
            tempUpdateCategory[i].coveragecategoryid;
          tempUpdateMap.modification_reason = this.memoString;
          tempUpdateMap.creator = this.userID;
          tempUpdateMap.creatorname = this.userName;
          needUpdateCategory.push(tempUpdateMap);
        }
        await insertDTMVZ006(this.userID, needUpdateCategory).then((result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "同步既有保障細項成功" });
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      }
      this.refshPage();
    },
    /** 覆核 */
    onCheck() {
      this.confirmType = "check";
      this.panelOpen("confirmModalOpen");
    },
    async doCheck() {
      //執行覆核(由後端自行查詢 DTMVZ006 的 I/U/D 紀錄處理)
      await doCheckCategory(this.userID, this.midCode).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "覆核成功" });
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
      //回到上一頁
      this.doCancel();
    },
    onConfirm() {
      switch (this.confirmType) {
          case "save": this.doSave(); break;
          case "check": this.doCheck(); break;
          default: break;
      }
      this.panelClose("confirmModalOpen")
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.block-b {
  display: flex;
  justify-content: space-between;
}
.block-c {
  display: flex;
  align-items: center;
  justify-content: center;
}
.block-d {
  display: flex;
  justify-content: flex-end;
}
.border-s-2 {
  border-style: solid;
  border-width: 2px;
  padding: 16px;
}
.text-size {
  font-size: 1rem;
}
.width-10 {
  width: 10%;
}
.width-20 {
  width: 20%;
}
.width-40 {
  width: 40%;
}
.width-45 {
  width: 45%;
}
.width-60 {
  width: 60%;
}
.width-80 {
  width: 80%;
}
.mg-b-8 {
  margin-bottom: 8px;
}
.mg-b-20 {
  margin-bottom: 20px;
}
.mg-b-40 {
  margin-bottom: 40px;
}
.mg-r-8 {
  margin-right: 8px;
}
.mg-r-40 {
  margin-right: 40px;
}
.mg-l-4 {
  margin-left: 4px;
}
.hr-dashed {
  border: 0;
  border-top: 2px dashed #a2a9b6;
}
.item-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.d-inline-center {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.selectBox1 {
  width: 100% !important;
  height: 250px !important;
  background-image: none;
}
.selectBox2 {
  width: 100% !important;
  height: 298.4px !important;
  background-image: none;
}
#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
</style>
